<template>
  <div :class="['card', { 'lite-promo': isPromo && isLite }, { 'pro-promo': isPromo && isPro }, { 'enterprise-promo': isPromo && isEnterprise }]">
    <div :class="['card-header', packageType,'card-content']">
      <div class="media-content">
        <p class="has-text-centered" v-text="title"></p>
        <p class="has-text-centered has-text-weight-bold" v-html="cost"></p>
      </div>
    </div>
    <div v-if="showLogoAndBody" class="card-image">
      <figure class="image">
        <img :src="getImageIconPath" :alt="title" />
        <div class="circle-border"></div>
      </figure>
    </div>
    <div v-if="showLogoAndBody" class="card-content">
      <div class="content">
        <p class="has-text-centered">
          <slot></slot>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PackageCard',
    props: {
      title: {
        type: String,
        default: 'LITE'
      },
      cost: {
        type: String,
        default: 'R699.00 pm'
      },
      packageType: {
        type: String,
        default: 'lite'
      },
      showLogoAndBody: {
        type: Boolean,
        default: true
      },
      isPromo: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        imageIcon: {
          lite: 'lite_icon.svg',
          pro: 'pro_icon.svg',
          enterprise: 'enterprise_icon.svg'
        }
      }
    },
    computed: {
      getImageIconPath () {
        return `/static/img/packages/${this.imageIcon[this.packageType]}`
      },
      isLite () {
        return this.packageType === 'lite'
      },
      isPro () {
        return this.packageType === 'pro'
      },
      isEnterprise () {
        return this.packageType === 'enterprise'
      }
    }
  }
</script>
<style scoped>
  .free + .card-image > .image, .lite + .card-image > .image, .pro + .card-image > .image, .enterprise + .card-image > .image {
    padding: 30px;
    border-radius: 50%;
    width: 150px;
    z-index: 1;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
  }

  .free + .card-image > .image {
    background-color: #e8f1f5;
  }

  .lite + .card-image > .image {
    background-color: #e9f8f6;
  }

  .pro + .card-image > .image {
    background-color: #fff1ee;
  }

  .enterprise + .card-image > .image {
    background-color: #f3f2fb;
  }

  .free + .card-image > .image > .circle-border, .lite + .card-image > .image > .circle-border,
  .pro + .card-image > .image > .circle-border, .enterprise + .card-image > .image > .circle-border {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: absolute;
    top: 25px;
    left: 25px;
    z-index: -1;
  }

  .free + .card-image > .image > .circle-border {
    background-color: #cfe2ea;
  }

  .lite + .card-image > .image > .circle-border {
    background-color: #d2f0ec;
  }

  .pro + .card-image > .image > .circle-border {
    background-color: #ffe3dc;
  }

  .image > img {
    width: 90px;
    height: 90px;
    z-index: 3;
  }

  .enterprise + .card-image > .image > .circle-border {
    background-color: #e7e4f7;
  }

  .header-copy {
    margin-top: 3rem;
    margin-bottom: 3rem;
    line-height: 2.9rem;
  }

  .card {
    box-shadow: none;
    border: 1px solid #e1dfdf;
  }

  .free, .pro, .lite, .enterprise {
    color: #ffffff;
  }

  .free {
    background-color: #1c7299;
  }

  .lite {
    background-color: #2dbaa4;
  }

  .pro {
    background-color: #ff7a59;
  }

  .enterprise {
    background-color: #8d7dda;
  }

  .card-header {
    font-weight: normal;
  }

  .card-header-title.is-centered {
    color: #ffffff;
    font-weight: lighter;
  }

  .card-header-title.is-centered {
    text-align: center;
  }

  .card > .card-header {
    padding: 1rem;
  }

  .card > .card-header > .media-content > p:first-child {
    font-size: 1.4rem;
    font-weight: lighter;
  }

  .card > .card-header > .media-content > p:not(:first-child) {
    font-size: 1.0rem;
    font-weight: bolder;
  }

  .card.lite-promo > .card-header > .media-content > p:not(:first-child), .card.pro-promo > .card-header > .media-content > p:not(:first-child), .card.enterprise-promo > .card-header > .media-content > p:not(:first-child) {
    font-size: 0.8rem;
    font-weight: normal!important;
  }

  figure img {
    border-radius: 0;
  }

  .lite-promo::before, .pro-promo::before, .enterprise-promo::before {
    content: '30% off';
    box-sizing: content-box;
    text-align: center;
    position: absolute;
    color: #ffffff;
    width: 100%;
    top: -25px;
    left: -1px;
    height: 25px;
    font-weight: bold;
    font-size: 0.8rem;
    line-height: 25px;
    border-top: 1px solid #e1dfdf;
    border-left: 1px solid #e1dfdf;
    border-right: 1px solid #e1dfdf;
  }

  .lite-promo::before {
    background-color: #259785;
  }

  .pro-promo::before {
    background-color: #FF602C;
  }

  .enterprise-promo::before {
    background-color: #663BDA;
  }

  @media screen and (max-width: 767px) {
    .header-copy {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    .card, .columns > .column {
      margin-top: 20px;
      margin-left: 30px;
      margin-right: 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/card/PackageCard.vue